import React, { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import tr from "date-fns/locale/tr";
import format from "date-fns/format";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import useLocale from "../../../helper/useLocale";
import { useTranslation } from "../../../context/TranslationContext";
import Image from "next/image";

const PageOne = ({ formdata, setformdata, validSteps, setvalidSteps }) => {
  const localeData = useLocale();
  const [isShow, setIsShow] = useState(false);
  const [state2, setState2] = useState([
    {
      startDate: formdata.startDate ? formdata.startDate : new Date(),
      endDate: formdata.endDate ? formdata.endDate : new Date(),
      key: "selection",
      isShow: 0,
    },
  ]);

  function ToggleShow() {
    setIsShow(!isShow);
  }
  function CloseToggle() {
    setIsShow(false);
  }

  function onChange(item) {
    setState2([item.selection]);
    if (item.selection.startDate !== item.selection.endDate) {
      CloseToggle();
    }
  }

  useEffect(() => {
    if (state2[0].startDate.toString() !== state2[0].endDate.toString()) {
      setvalidSteps({ ...validSteps, 1: true });
      setformdata({
        ...formdata,
        startDate: state2[0].startDate,
        endDate: state2[0].endDate,
      });
    } else {
      setvalidSteps({ ...validSteps, 1: false });
      setformdata({
        ...formdata,
        startDate: null,
        endDate: null,
      });
    }
  }, [state2]);

  const {
    getOfferStep1Title1,
    getOfferStep1Title2,
    getOfferStep1Caption1,
    getOfferStep1Caption2,
    getOfferStep1SubTitle,
  } = useTranslation();

  return (
    <>
      <div className="mb-4">
        <div className="flex flex-col items-start mb-10">
          <span className="text-black text-2xl mm:text-3xl ml:text-[35px] font-medium leading-[20px]">
            {getOfferStep1Title1}
          </span>
          <span className="text-[#ed7824] text-[35px] font-medium">
            {getOfferStep1Title2}
          </span>
        </div>
        <div className="flex flex-col lg:mb-[62px] mb-7">
          <span className="md:text-[31px] sm:text-25 text-[18px] text-black font-bold mb-2 leading-8 mb-2">
            {getOfferStep1Caption1}
            <span className="md:text-[31px] sm:text-25 text-[18px] font-bold text-[#E66E07] ml-1">
              {getOfferStep1Caption2}
            </span>
          </span>
          <span className="md:text-[21px] text-15 text-black font-medium leading-7 md:mb-1">
            {getOfferStep1SubTitle}
          </span>
          <span className="sm:text-[15px] text-13 text-black font-normal leading-5"></span>
        </div>

        <div className="inline-flex flex-wrap relative">
          <div
            className="border border-[#E5E7ED] md:px-[62px] sm:px-9 px-4 md:py-[25px] py-4 flex  items-center cursor-pointer"
            onClick={() => ToggleShow()}
          >
            <span className="xl:text-[15px] text-13 text-black font-normal ">
              {format(state2[0].startDate, "dd MMMM Y", { locale: localeData })}
            </span>
            <div className="w-[38px] h-[29px] md:mx-[73px] sm:mx-7 mx-4 relative">
              <Image src={"/icons/date.svg"} layout="fill" alt="" />
            </div>
            <span className="xl:text-[15px] text-13 text-black font-normal ">
              {format(state2[0].endDate, "dd MMMM Y", { locale: localeData })}
            </span>
          </div>
          <div
            className={
              "absolute top-full " + (isShow ? "inline-block z-50" : "hidden")
            }
          >
            {localeData && (
              <DateRange
                editableDateInputs={false}
                onChange={(item) => onChange(item)}
                moveRangeOnFirstSelection={false}
                ranges={state2}
                showDateDisplay={false}
                locale={localeData}
                months={1}
                minDate={new Date()}
                showMonthAndYearPickers={false}
                direction="horizontal"
                className="availability-calendar"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageOne;
